import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const DangerIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\uf654'}</MuiIcon>
    );
}
